import React, { Component } from "react";
import "../Login/styles.css";
import NewUserAuth from "../Login/Components/NewUserAuth.jsx";

class CreateUser extends Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 1000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 1000);
      }
    });
  }
  render() {
    return (
      <React.Fragment>
        <NewUserAuth />
      </React.Fragment>
    );
  }
}

export default CreateUser;
